import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import { GetUserRewardDocuments } from '../../redux/constants/apiConstants';
import { ImageUrl } from '../../utils/constants';
import SkeletonLoder from '../../components/common/skeletonLoder';
import { HeaderRow } from '../../components/EventDetails/styles';
import { RewarDocumentsContainer, NoData } from '../../components/RewardsManagement/Documents/styles';
import SearchInput from '../../components/RewardsManagement/Documents/SearchInput';
import { GridViewRewardIcon, ListViewRewardIcon, SortIcon } from '../../utils/icons';
import { DownAngleV2 } from '../../components/SocialFeedsV2/styles';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import CommonListView from '../../components/common/CommonListView/CommonListView';
import styled from 'styled-components';
import { NewVideoPlayer } from '../../components/MainEvents/RecommendEventVideos/styles';
import Thumbnail from '../../components/Thumbnail';
import { RelatedCard, RelatedCardContainer } from '../../components/VideoArticle/styles';
import { DetailsContainer, Row, Title, DownloadsContainer, BottomRow, LastUpdated } from '../../components/RewardsManagement/Documents/DocumentsGridCard';
import { DocumentIcon, FallbackRewardDocIcon, JpgIcon, PdfIcon, PngIcon, SheetIcon, VerticalDotsIcon } from '../../utils/icons';

const DocCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  text-align: left;
`;

const DocIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #184a61;
  font-family: Lato;
  font-size: 14px;
`;

const DocName = styled.span`
  color: #184a61;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

const TextCell = styled.div`
  color: #184a61;
  font-family: Lato;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const DownloadItem = styled(Dropdown.Item)`
  background-color: #da6c74 !important;
  color: #fff !important;
  &:hover {
    background-color: #da6c74 !important;
  }
`;

const headers = [
  { key: 'doc', label: 'Doc Name', align: 'start' },
  { key: 'downloads', label: '' },
  { key: 'uploaded_by', label: 'Uploaded By' },
  { key: 'last_updated', label: 'Last Updated' },
  { key: 'action', label: '' },
];

const getFileIcon = (ext = '', size) => {
  switch (ext.toLowerCase()) {
  case 'pdf': return <PdfIcon width={size} height={size} />;
  case 'jpeg': case 'jpg': return <JpgIcon width={size} height={size} />;
  case 'png': return <PngIcon width={size} height={size} />;
  case 'csv': case 'xls': case 'xlsx': return <SheetIcon width={size} height={size} />;
  case 'doc': case 'docx': return <DocumentIcon width={size} height={size} />;
  default: return <FallbackRewardDocIcon width={size} height={size} />;
  }
};

const UserDocuments = () => {
  const [documentsData, setDocumentsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('list');
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('');
  const [onHover, setOnHover] = useState(null);

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async (searchValue = search, sortValue = sort) => {
    setLoading(true);
    try {
      const res = await fetchApi(GetUserRewardDocuments, 'GET');
      if (res.status === 'success') {
        let data = res?.data?.documents || res?.data || [];
        if (searchValue) {
          data = data.filter((d) => d.title?.toLowerCase().includes(searchValue.toLowerCase()));
        }
        if (sortValue === 'a_z') data = [...data].sort((a, b) => a.title?.localeCompare(b.title));
        if (sortValue === 'most_downloaded') data = [...data].sort((a, b) => b.downloads - a.downloads);
        if (sortValue === 'newest') data = [...data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        if (sortValue === 'oldest') data = [...data].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        setDocumentsData(data);
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };

  const downloadDoc = async (doc) => {
    try {
      const response = await fetch(ImageUrl + '/' + doc?.document, { mode: 'cors' });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = doc?.title || 'download';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (e) {
      window.console.error(e);
    }
  };

  const renderCell = (key, doc) => {
    if (key === 'doc') {
      return (
        <DocCell>
          <DocIcon>{getFileIcon(doc?.extension)}</DocIcon>
          <DocName>{doc?.title}</DocName>
        </DocCell>
      );
    }
    if (key === 'downloads') return <TextCell style={{ visibility: 'hidden' }}>{doc.downloads}</TextCell>;
    if (key === 'uploaded_by') return <TextCell>{doc?.uploaded_by}</TextCell>;
    if (key === 'last_updated') return <TextCell>{doc?.last_updated}</TextCell>;
    if (key === 'action') {
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <DownAngleV2 feed padding="0 16px" marginL="-140px">
            <DropdownButton id="docMenu" title={<VerticalDotsIcon />}>
              <DownloadItem onClick={() => downloadDoc(doc)}>Download</DownloadItem>
            </DropdownButton>
          </DownAngleV2>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <RewarDocumentsContainer>
        <SearchInput
          placeholder="Search"
          onChange={(value) => {
            setSearch(value);
            fetchDocuments(value, sort);
          }}
        />
        <div className="icons-container">
          {view === 'list' && (
            <span className="icons" onClick={() => setView('grid')}>
              {ListViewRewardIcon()}
            </span>
          )}
          {view === 'grid' && (
            <span className="icons" onClick={() => setView('list')}>
              {GridViewRewardIcon()}
            </span>
          )}
          <div className="menu">
            <DownAngleV2 feed padding="0 16px" marginL="-35px" style={{ marginLeft: '0px' }}>
              <DropdownButton id="sortDocs" title={<SortIcon />}>
                <Dropdown.Item onClick={() => { setSort('a_z'); fetchDocuments(search, 'a_z'); }}>A-Z Order</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSort('most_downloaded'); fetchDocuments(search, 'most_downloaded'); }}>Most Download</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSort('newest'); fetchDocuments(search, 'newest'); }}>Newest</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSort('oldest'); fetchDocuments(search, 'oldest'); }}>Oldest</Dropdown.Item>
              </DropdownButton>
            </DownAngleV2>
          </div>
        </div>
      </RewarDocumentsContainer>

      {loading ? (
        <HeaderRow>
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonLoder key={i} width="1248px" height="387px" />
          ))}
        </HeaderRow>
      ) : view === 'grid' ? (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {documentsData.length ? (
            documentsData.map((doc) => (
              <RelatedCardContainer key={doc.id} margin="0px 20px 20px 0px" height="326px">
                <RelatedCard onMouseEnter={() => setOnHover(doc.id)} onMouseLeave={() => setOnHover(null)}>
                  <NewVideoPlayer height="242px">
                    <Thumbnail style={{ cursor: 'default' }} src={`${ImageUrl}/${doc?.document_image}`} alt="doc" height="242px" />
                  </NewVideoPlayer>

                  {onHover === doc.id && (
                    <div className="educateImageBackground">
                      <div className="getStarted" onClick={() => downloadDoc(doc)}>Download</div>
                    </div>
                  )}

                  <DetailsContainer>
                    <Row>
                      <Title title={doc?.title}>{doc?.title}</Title>
                      <DownloadsContainer>
                        {/* Eyeicon function was missing in snippet, assuming global or added in utils */}
                        {/* {typeof Eyeicon === 'function' ? Eyeicon() : null} */}
                        {doc?.downloads}
                      </DownloadsContainer>
                    </Row>
                    <BottomRow>
                      <LastUpdated>
                        <div>{getFileIcon(doc?.extension, '24px')}</div>
                        <div>Last Updated: {doc?.last_updated}</div>
                      </LastUpdated>
                    </BottomRow>
                  </DetailsContainer>
                </RelatedCard>
              </RelatedCardContainer>
            ))
          ) : (
            <NoData>No Documents Available</NoData>
          )}
        </div>
      ) : (
        documentsData.length ? (
          <CommonListView
            headers={headers}
            data={documentsData}
            grid="2fr 1fr 1.5fr 1.5fr 100px"
            renderCell={renderCell}
          />
        ) : (
          <NoData>No Documents Available</NoData>
        )
      )}
    </>
  );
};

export default UserDocuments;